// extracted by mini-css-extract-plugin
export default {"root":"LXG9G","text-block":"yhbz2","textBlock":"yhbz2","prefix":"_35GoC"};